import {match} from 'ts-pattern';

import {FinancingStatusResponseBodySaleVehiclePhoto} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

// Human text for a non-READY financing promo card; unknown BE reasons are shown verbatim.
// ABANDONED is terminal and its free-text reason is technical, so only the status is shown.
export const getFinancingPromoStatusText = (
  entry: Pick<FinancingStatusResponseBodySaleVehiclePhoto, 'status' | 'reason'>
) =>
  match(entry)
    .with({status: 'ABANDONED'}, () => i18n.t('entity.photo.financingPromo.status.abandoned'))
    .with({reason: 'MISSING_PHOTO'}, () =>
      i18n.t('entity.photo.financingPromo.reasons.missingPhoto')
    )
    .with({reason: 'PHOTO_NOT_READY'}, () =>
      i18n.t('entity.photo.financingPromo.reasons.photoNotReady')
    )
    .with({reason: 'NO_AVAILABLE_OFFER'}, () =>
      i18n.t('entity.photo.financingPromo.reasons.noAvailableOffer')
    )
    .with({reason: 'MISSING_FIELD_VALUE'}, () =>
      i18n.t('entity.photo.financingPromo.reasons.missingFieldValue')
    )
    .with({reason: 'SUPPRESSED'}, () => i18n.t('entity.photo.financingPromo.reasons.suppressed'))
    .with({reason: 'NOT_PREFERRED'}, () =>
      i18n.t('entity.photo.financingPromo.reasons.notPreferred')
    )
    .with({reason: 'INVALID_COMPOSITION'}, () =>
      i18n.t('entity.photo.financingPromo.reasons.invalidComposition')
    )
    .with({reason: 'TEXT_OVERFLOW'}, () =>
      i18n.t('entity.photo.financingPromo.reasons.textOverflow')
    )
    .with({status: 'PENDING'}, () => i18n.t('entity.photo.financingPromo.status.pending'))
    .with({status: 'FAILED', reason: null}, () =>
      i18n.t('entity.photo.financingPromo.status.failed')
    )
    .otherwise(({reason}) => reason ?? i18n.t('entity.photo.financingPromo.status.failed'));
